/* MYPARF — recently viewed (localStorage only, visitor's own browser, max 8 handles). */
(function () {
  var root = document.querySelector('.myparf-recently-viewed');
  if (!root || !('localStorage' in window)) return;
  var KEY = 'myparf:recently-viewed';
  var current = root.dataset.currentHandle;
  var list;
  try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }

  // render previous history (excluding the product being viewed)
  var toShow = list.filter(function (h) { return h && h !== current; }).slice(0, 4);
  if (toShow.length) {
    root.querySelector('.title').textContent = root.dataset.heading;
    var grid = root.querySelector('.myparf-recent-grid');
    Promise.all(
      toShow.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      products.filter(Boolean).forEach(function (p) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = p.url;
        if (p.featured_image) {
          var img = document.createElement('img');
          img.src = p.featured_image;
          img.alt = p.title;
          img.loading = 'lazy';
          img.width = 300;
          img.height = 300;
          a.appendChild(img);
        }
        var t = document.createElement('span');
        t.className = 'myparf-recent__title';
        t.textContent = p.title;
        a.appendChild(t);
        var pr = document.createElement('span');
        pr.className = 'myparf-recent__price';
        // products awaiting an owner-approved price carry the 'prix-en-attente' tag and a
        // technical 0 price — show the pending label, never 0.00 (label injected via data attr)
        var pending = (p.tags || []).indexOf('prix-en-attente') !== -1;
        if (pending) {
          pr.classList.add('myparf-price-pending');
          pr.textContent = (root.dataset.pendingLabel || 'Prix communiqué prochainement');
        } else {
          pr.textContent = (p.price / 100).toFixed(2) + ' ' + (window.Shopify && Shopify.currency ? Shopify.currency.active : 'MAD');
        }
        a.appendChild(pr);
        li.appendChild(a);
        grid.appendChild(li);
      });
      if (grid.children.length) root.hidden = false;
    });
  }

  // record the current product
  if (current) {
    var next = [current].concat(list.filter(function (h) { return h !== current; })).slice(0, 8);
    try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { /* storage full/blocked — ignore */ }
  }
})();
